/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-nested-ternary */
import {
    Breadcrumb, Button, Panel, FloatingActionButton, Tabs,
    Tab,
} from 'appkit-react';
import ReactFlow from 'react-flow-renderer';
import { scroller, animateScroll as scroll } from 'react-scroll';
import { useHistory } from 'react-router-dom';

// eslint-disable-next-line import/no-unresolved
import Loader from 'views/Shared/components/Loader';
import DefaultAlert from '../../../Shared/components/DefaultAlert';
import SpecialCustomNode from '../../DataConfiguration/components/SpecialCustomNode';
import InputCustomNode from '../../DataConfiguration/components/InputCustomNode';
import DefaultCustomNode from '../../DataConfiguration/components/DefaultCustomNode';
import CustomEdge from '../../DataConfiguration/components/CustomEdge';
import DataStopDetails from './DataStopDetails';
import SuccessResult from './SuccessResult';
import ExceptionResult from './ExceptionResult';
import FileData from './FileData';
import ReconComment from './ReconComment';
import '../styles/reconResult.scss';

const nodeTypes = {
    special: SpecialCustomNode,
    input: InputCustomNode,
    default: DefaultCustomNode,
};
const edgeTypes = {
    special: CustomEdge,
    input: CustomEdge,
    default: CustomEdge,
};
const scrollToSection = () => {
    scroller.scrollTo('comment-section', {
        duration: 500,
        delay: 0,
        smooth: 'easeInOutQuart',
    });
};

const ReconResult = ({
    columns, initials, commentData, itemsToShow, setItemsToShow, showAllCommentsBtn,
    setShowAllCommentsBtn, breadCrumbItems, project, comments, setComments,
    createComment, downloadFile, elements, onElementClick, childFlow, configLoading,
    successData, exceptionData, nodeConfig, fileData, fileCols,
    fileName, fileDataLoading, resultDataLoading, setActiveTab, disableFileTab,
    isfilteredData, createIsLoading, toastMessage, setToastMessage, isFileDownloading,
}) => {
    const onTabChange = k => setActiveTab(k);
    const history = useHistory();
    const onElementSelect = (event, element) => {
        onElementClick(event, element);
        scroller.scrollTo('data-preview', {
            duration: 800,
            delay: 100,
            smooth: 'easeInOutQuart',
        });
    };

    const isDataAvailable = successData.length !== 0 || exceptionData.length !== 0;
    const isDataLoading = resultDataLoading || fileDataLoading;
    return (
        <div className="true-comply-data-recon-result_layout">
            <div className="true-comply-data-recon-result_page">
                <Breadcrumb items={breadCrumbItems} />

                {toastMessage
                    && (
                        <DefaultAlert
                            status="success"
                            toastMessage={toastMessage}
                            setToastMessage={setToastMessage}
                        />
                    )}

                <div className="a-h3">
                    <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.goBack()} role="presentation" />
                    {`${project?.projectName || ''} - Reconciliation Result`}
                    <Button size="lg" style={{ float: 'right' }} onClick={() => scrollToSection()}>
                        ADD COMMENTS
                    </Button>
                </div>
                <Panel style={{ marginTop: '1.5rem' }}>
                    {!configLoading && (
                        <div className="result-reactflow-wrapper">
                            <ReactFlow
                                elements={elements}
                                onElementClick={onElementSelect}
                                nodeTypes={nodeTypes}
                                edgeTypes={edgeTypes}
                                key="edges"
                            >
                                <div style={{
                                    position: 'absolute',
                                    left: 10,
                                    top: 7,
                                    zIndex: 4,
                                }}
                                >
                                    <div style={{ marginBottom: '2.5rem' }}>
                                        <Breadcrumb items={childFlow} style={{ paddingBottom: '0.8rem', border: 'none' }} />
                                    </div>
                                </div>
                                <div style={{
                                    position: 'absolute',
                                    right: 10,
                                    bottom: 25,
                                    zIndex: 4,
                                }}
                                >
                                    <div style={{ marginBottom: '1.5rem' }}>
                                        <p className="a-h6">LEGEND</p>
                                        <span className="appkiticon icon-check-mark-fill" style={{ fontSize: '1rem', color: '#22992E', marginRight: '1.5rem' }}> Success </span>
                                        <span className="appkiticon icon-close-fill" style={{ fontSize: '1rem', color: '#C52A1A', marginRight: '1.5rem' }}> Exception </span>
                                    </div>
                                </div>
                            </ReactFlow>
                        </div>
                    )}
                    {configLoading && (
                        <Loader />
                    )}
                </Panel>
                {fileData.length === 0 && isDataAvailable && (
                    <DataStopDetails
                        downloadFile={downloadFile}
                        isFileDownloading={isFileDownloading}
                        successData={successData}
                        exceptionData={exceptionData}
                        nodeConfig={nodeConfig}
                    />
                )}

                <Panel
                    style={{ marginTop: '1.5rem', paddingBottom: '1rem' }}
                    title="DATA PREVIEW"
                    className="data-preview"
                >
                    {isDataLoading ? (
                        <Loader />
                    ) : (
                        <>
                            {disableFileTab && (
                                <Tabs
                                    id="controlled-tab-example"
                                    defaultValue="1"
                                    onChange={onTabChange}
                                    className="mb-3"
                                >
                                    <Tab value="1" label="RESULT">
                                        <SuccessResult
                                            fileName={fileName}
                                            successData={successData}
                                            columns={columns}
                                        />
                                    </Tab>
                                    <Tab value="2" label="EXCEPTION">
                                        <ExceptionResult
                                            fileName={fileName}
                                            exceptionData={exceptionData}
                                            columns={columns}
                                        />
                                    </Tab>
                                </Tabs>
                            )}
                            {!disableFileTab && (
                                <FileData
                                    fileName={fileName}
                                    disableFileTab={disableFileTab}
                                    isfilteredData={isfilteredData}
                                    fileData={fileData}
                                    fileCols={fileCols}
                                    onTabChange={onTabChange}
                                />
                            )}
                        </>
                    )}
                </Panel>

                <ReconComment
                    initials={initials}
                    comments={comments}
                    setComments={setComments}
                    createComment={createComment}
                    setToastMessage={setToastMessage}
                    commentData={commentData}
                    createIsLoading={createIsLoading}
                    showAllCommentsBtn={showAllCommentsBtn}
                    setShowAllCommentsBtn={setShowAllCommentsBtn}
                    itemsToShow={itemsToShow}
                    setItemsToShow={setItemsToShow}
                />
                <div style={{
                    position: 'fixed',
                    right: 10,
                    bottom: 0,
                    zIndex: 4,
                }}
                >
                    <FloatingActionButton kind="primary" onClick={() => scroll.scrollToTop()}>
                        <span className="appkiticon a-btn-icon icon-up-chevron-fill" />
                    </FloatingActionButton>
                </div>
            </div>
        </div>
    );
};

export default ReconResult;
